import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-dark text-white text-center p-3 mt-auto">
      <div className="container">
        <p className="mb-2">&copy; {new Date().getFullYear()} CUDA. Todos los derechos reservados.</p>
        <div style={{ fontSize: '0.75rem' }}>
          <Link to="/terms" target="_blank" rel="noopener noreferrer" className="text-white-50 text-decoration-none me-3">Términos y Condiciones</Link>
          <Link to="/privacy" target="_blank" rel="noopener noreferrer" className="text-white-50 text-decoration-none">Política de Privacidad</Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
